import { combineReducers } from "@reduxjs/toolkit";
import { authReducer, userReducer, configReducer } from "@stadium/redux-utils/slices";

/*
  ================ REDUCERS ================
 */
import cart from "@slices/cart";
import country from "@slices/country";
import menu from "@slices/menu";
import order from "@slices/order";
import store from "@slices/store";
/*
  ================ REDUCERS ================
*/

const appReducer = combineReducers({
  auth: authReducer,
  cart,
  config: configReducer,
  country,
  menu,
  order,
  store,
  user: userReducer,
});

const rootReducer = (state = {}, action) => appReducer(state, action) || state;

export default rootReducer;
